import { validator } from "@/utils/validator";

export const loginSchema = validator.object().shape({
  externalId: validator.string().trim().emptyToNull().autoTransformToHalfWidth().label("組織ID").required(),
});
